import { Link } from 'react-router';

import { Container } from '@/components/ui/Container';

export function NotFoundPage() {
  return (
    <Container className="py-20 text-center">
      <p className="text-sm font-semibold tracking-widest text-brand-600">404</p>
      <h1 className="mt-3 text-3xl font-bold tracking-tight text-ink">Page not found</h1>
      <p className="mx-auto mt-3 max-w-md text-muted">
        The page you are looking for does not exist or has not shipped yet.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex h-11 items-center rounded-xl bg-brand-500 px-6 text-sm font-semibold text-white transition-colors hover:bg-brand-600"
      >
        Back to home
      </Link>
    </Container>
  );
}
